module.exports = __webpack_public_path__ + "img/PXL_20230524_183150336.7525cec0.jpg";